import { render, staticRenderFns } from "./ImagemCarouselDialog.vue?vue&type=template&id=a5448d20&scoped=true"
import script from "./ImagemCarouselDialog.vue?vue&type=script&lang=js"
export * from "./ImagemCarouselDialog.vue?vue&type=script&lang=js"
import style0 from "./ImagemCarouselDialog.vue?vue&type=style&index=0&id=a5448d20&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5448d20",
  null
  
)

export default component.exports